import React from 'react';
import classNames from 'classnames';

export default class FieldHint extends React.Component {
  render() {
    return (
      <div
        className={classNames(
          'margin-top-xs font-size-xs line-height-title color-muted',
          this.props.className
        )}
      >
        {this.props.children}
      </div>
    );
  }
}
